/**
 * Checks if and element contains the target.
 *
 * @param {Node} element
 * @param {Node} target
 * @returns {boolean}
 */
export default function contains (element, target) {
  if (!element) return false
  if (element.contains) return element.contains(target)

  let node = target

  do {
    if (element === node) return true
    node = node.parentNode
  } while (node)

  return false
}
